export default {
  REELS_COUNT: 5,
  ELEMENTS_COUNT: 12,
  MULTIPLIER_BIG_WIN: 10,
  MULTIPLIER_MEGA_WIN: 20,
};
